<mp-search-field
  class="raised"
  placeholder="Nach Katalog/Lieferant suchen"
  [searchTerm]="searchTerm()"
  (searchTermChange)="onSearchbarSubmitted($event)"
/>

<div class="filter-status">
  <mp-multi-selection-group
    filterName="Offene Zuordnungen"
    icon="task"
    [options]="catalogOpenTasksFilterOptions"
    [selectedValues]="selectedOpenTasks()"
    (selectedValuesChange)="handleFilterChanges({ openTasks: $event })"
  />

  <mp-multi-selection-group
    filterName="Datenquellen"
    icon="topic"
    [searchable]="true"
    searchFieldPlaceholder="Datenquellen durchsuchen"
    [sortOptionsBySelection]="true"
    [options]="dataSourceFilterOptions()"
    [selectedValues]="selectedDataSources()"
    (selectedValuesChange)="handleFilterChanges({ datasources: $event })"
  />
</div>
